<template>
	<div>
		<!-- action="http://admin.ciaojian.com/file/upload" localhost:8089 -->
		<el-upload class="upload__" multiple action="https://admin.ciaojian.com/file/file_upload"
			list-type="picture-card" :show-file-list="false" :on-success="oploads" :before-upload="beforeUpload">
			<el-image v-if="img" :src="img" style="overflow: hidden;width: 100%;height: 100%;" />
			<i v-else :id="tid" refs="selects" class="el-icon-plus avatar-uploader-icon" />
		</el-upload>
		<el-dialog :visible.sync="dialog_show" append-to-body>
			<img width="100%" :src="dialog_img" alt="">
		</el-dialog>
	</div>
</template>

<script>
	// import { getToken } from '@/utils/auth'
	// import { getUrl } from '@/api/api'
	export default {
		model: {
			prop: 'img',
			event: 'upload'
		},
		props: {
			img: String,
			tid: String
		},
		data() {
			return {
				dialog_img: '',
				dialog_show: false
			}
		},
		methods: {
			preview_img(file) {
				this.dialog_img = file.url
				this.dialog_show = true
			},
			beforeUpload(file) {

				var imglist = ['image/jpeg', 'image/png', 'image/gif']

				const isLt2M = file.size / 1024 / 1024 < 2
				imglist.find(function(value) {
					if (value == file.type) return true;
				})
			},
			oploads(res) {
				if (res.code == 200) {
					// if(this.img) this.$http.post("file/del", JSON.stringify(this.img));
					this.$emit('upload', res.data);
				}
			}
		}
	}
</script>

<style>
	.el-upload {
		overflow: hidden;
	}

	.el-upload img {
		width: 100%;
	}

	.upload__ {
		width: 100%;
		height: 100%;
	}

	.upload__ .el-upload--picture-card {
		width: 100%;
		height: 100%;
		line-height: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>